import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCommonworkflowlanguageComponent } from './simple-icons-commonworkflowlanguage.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCommonworkflowlanguageComponent ],
    exports:      [ SimpleIconsCommonworkflowlanguageComponent ],
    bootstrap:    []
})
export class SimpleIconsCommonworkflowlanguageModule {}
